import AxiosConfig from "./AxiosConfig";

const sendMsg = async (values) => {
    try {
        const response = await AxiosConfig.post('/report', {"values": values});
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getReports = async (id) => {
    try {
        const response = await AxiosConfig.get('/reports/'+id);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export { sendMsg, getReports };